const roadmapPage = {
  title: "Roadmap",
  description: "Development phases for vBrain.io",
  back: "Back",
  openInNotion: "Open in Notion",
  taskCount: "items",
  effort: "Effort",
  goal: "Goal",
  epic: "Epic",
  sprint: "Sprint",
  task: "Task",
  portfolio: "Portfolio",
  project: "Project",
  subTask: "Sub-task",
  notStarted: "Not Started",
  inProgress: "In Progress",
  complete: "Complete",
  allItems: "All Items",
  noItems: "No items in this layer",
  drillDown: "View",
  breadcrumbHome: "Goals",
  viewHierarchy: "Hierarchy",
  viewPortfolio: "By Portfolio",
  viewStatus: "By Status",
  viewSprint: "By Sprint",
  noStatus: "No Status",
  portfolioCount: "portfolios",
  projectCount: "projects",
  sprintCount: "sprints",
  doneLabel: "done",
  assignedTasks: "assigned",
  unassignedTasks: "unassigned",
  unassignedTasksTitle: "Unassigned Tasks",
} as const;
export default roadmapPage;
